export const useBillingCodesStore = defineStore('billing-codes', {
  actions: {
    getBillingCodes({ query, top }: { query?: string; top?: number } = { query: '', top: 30 }) {
      const apiStore = useApiStore();

      return apiStore.api.billingCodes.billingCodesSearch({ query, top });
    }
  },
  persist: {
    storage: persistedState.localStorage
  }
});
